import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ToastBaseModel {

    public Personal = 'Personal Details';
    public Qualification = 'Qualification Details';
    public Twilight = 'Official Details';
    public System = 'System Details';
    public Resignation = 'Resignation Details';
    public Experience = 'Experience Details';
    public Skill = 'Skills Details';
    public Salary = 'Salary Details';
    public Bonus = 'Bonus Details';
    public Increment = 'Increment Details';
    public ImageSize = 'Image must be less than 1 MB';
    public ImageType = 'File supports only .jpg, .jpeg, .png and .gif';
    public ImageSuccessful = 'Profile Image Updated has been added successfully';

    public Save = 'Saved Successfully';
    public Delete = 'Deleted Successfully';
    public Update = 'Updated Successfully';
    public Invalid = 'Please enter all the fields';
}